module.exports = __webpack_public_path__ + "img/misty_pines_2k.6bce70b8.png";